<template>
	<v-layout
		row
		wrap
		justify-center
		align-center
	>
		<v-flex xs12 xl8>
			<h4 class="display-1 mb-3">Project Settings</h4>
			<table class="headline mb-4">
				<tr>
					<td>Active projects:</td>
					<td>{{ projects.length }}</td>
				</tr>
				<tr>
					<td>Archived projects:</td>
					<td>{{ archivedProjects.length }}</td>
				</tr>
			</table>
			<NewProject
				:existing-projects="projects.getNames()"
				align-button="left"
				:redirect-on-create="false"
				v-if="isProjectCreator"
			/>

		</v-flex>
	</v-layout>
</template>

<script>
import NewProject from '@/components/Project/NewProject';

export default {
	components: {
		NewProject,
	},
	computed: {
		projects() {
			return this.$store.get('projects/active');
		},
		archivedProjects() {
			return this.$store.get('projects/archived');
		},
		isProjectCreator() {
			if (this.$store.get('superUser')) {
				return true;
			}

			const roles = this.$ls.get('roles');

			return (roles.indexOf('project_creator') > -1);
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	tr {
		td:first-child {
			padding-right: 15px;
		}
		td:last-child {
			text-align: center;
		}
	}
}
</style>
